import styled from "@emotion/styled";
import _LottieImport from "lottie-react";

// Vite may resolve the UMD build, wrapping the component in a module object
const Lottie: typeof _LottieImport =
  typeof _LottieImport === "function"
    ? _LottieImport
    : (_LottieImport as any).default;
import { breakpoints, borderRadius, fontSize } from "@atlas-int/tokens";

const AnimationWrapper = styled.div`
  width: 400px;
  height: 395px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (max-width: ${breakpoints.lg}) {
    width: 340px;
    height: 336px;
  }

  @media (max-width: ${breakpoints.md}) {
    width: 280px;
    height: 277px;
  }

  @media (max-width: ${breakpoints.headerMobile}) {
    width: 180px;
    height: 178px;
  }

  @media (max-width: ${breakpoints.xxs}) {
    width: 140px;
    height: 138px;
  }
`;

const PlaceholderBox = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.08);
  border: 2px dashed rgba(255, 255, 255, 0.25);
  border-radius: ${borderRadius.full};
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: ${fontSize.base};
  text-align: center;
  padding: 1rem;
`;

interface Props {
  animationData?: object;
}

const HeaderAnimation = ({ animationData }: Props) => {
  if (!animationData) {
    return (
      <AnimationWrapper>
        <PlaceholderBox>Globe Animation<br />Placeholder</PlaceholderBox>
      </AnimationWrapper>
    );
  }

  return (
    <AnimationWrapper>
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        style={{ width: "100%", height: "100%" }}
      />
    </AnimationWrapper>
  );
};

export default HeaderAnimation;
